import { useEffect, useRef, useState } from "react"
import { Navigate, useLocation, useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { ErrorBoundary } from "react-error-boundary"
import ReactGA from "react-ga4"

import { Navbar, Sidebar } from "../../components"
import { ErrorFallbackMessage } from "../../components/common"

const useScrollChangeHandler = () => {
  const containerRef = useRef(null);
  const { pathname, search } = useLocation();

  // Scroll container to top when switching between matches and candidates
  useEffect(() => {
    if (pathname.includes("/matches") && containerRef.current) {
      containerRef.current.scrollTop = 0;
    }
  }, [pathname, search]);

  const { jobId } = useParams();
  const storedJob = useSelector((state) => state.jobs.jobs?.[jobId])
  const jobStatus = useSelector((state) => state.jobs.jobStatus);
  
  // Scroll to bottom when new data is received or job status changes while Processing a Job (streaming)
  useEffect(() => {
    if (pathname.includes("/requirements") && containerRef.current) {
      containerRef.current.scrollTo({ top: containerRef.current.scrollHeight, behavior: "smooth" });
    }
  }, [pathname, jobId, storedJob, jobStatus]);

  return { containerRef };
};

const AuthenticatedLayout = ({
  children,
  Sidebar: Sbar,
  roles,
  allowOnboardingUsers = false,
  hideForTrialingUsers = false,
}) => {
  const [user, setUser] = useState(null);
  const auth = useSelector((state) => state.auth)
  const { pathname } = useLocation()

  const { containerRef } = useScrollChangeHandler();

  if (!auth.isAuthenticated) {
    if (user) {
      setUser(null);
      ReactGA.set({ userId: null })
    }

    return <Navigate to={"/login"} />
  }

  if (!user) {
    ReactGA.set({ userId: auth.user.id })
    setUser(auth.user.id)
  }

  if (hideForTrialingUsers) {
    if (auth.onboardingStage === "Trialing") {
      return <Navigate to={"/job-match/select-cv"} />
    }
  }

  // if (
  //   !allowOnboardingUsers && auth.onboardingStage === "Trialing"
  // ) {
  //   return <Navigate to={"/job-match/select-cv"} />
  // }

  // if (
  //   auth.onboardingStage === "PaymentPending" &&
  //   pathname !== "/pending-payment"
  // ) {
  //   return <Navigate to={"/pending-payment"} />
  // }

  if (roles && !roles.includes(auth.role?.role)) {
    return <Navigate to={"/job-match/select-cv"} />
  }

  return (
    <main className="app">
      {Sbar || <Sidebar />}
      <div
        ref={containerRef}
        className="content-container"
      >
        <Navbar />
        <ErrorBoundary
          fallback={<ErrorFallbackMessage />}
        >
          {children}
        </ErrorBoundary>
      </div>
    </main>
  )
}

export default AuthenticatedLayout
